import { store } from 'redux/store';
import { useCallback, useEffect, useState } from 'react';

import { Document, Society } from 'types';

import { getDocument } from 'modules/documents/redux/documentActions';

type UseGetSocietyShareTitleDocumentProps = {
  society: Society;
};

export const useGetSocietyShareTitleDocument = ({
  society,
}: UseGetSocietyShareTitleDocumentProps) => {
  const [document, setDocument] = useState<Document>();
  const [documentWithCoOwners, setDocumentWithCoOwners] = useState<Document>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchDocument = useCallback(
    async (controller: AbortController) => {
      if (!society) return;

      try {
        setIsLoading(true);

        const documentId = society?.templates?.sharesTitle;
        const documentIdWithCoOwners =
          society?.templates?.sharesTitleWithCoOwners;

        if (documentId) {
          const document = await store.dispatch(getDocument(documentId));
          setDocument(document);
        }

        if (documentIdWithCoOwners) {
          const documentWithCoOwners = await store.dispatch(
            getDocument(documentIdWithCoOwners)
          );
          setDocumentWithCoOwners(documentWithCoOwners);
        }

        if (!controller.signal.aborted) {
          setIsLoading(false);
        }
      } catch (error) {
        if (!controller.signal.aborted) {
          setIsLoading(false);
        }
      }
    },
    [society]
  );
  useEffect(() => {
    const controller = new AbortController();

    fetchDocument(controller);

    return () => controller.abort();
  }, [fetchDocument]);

  return {
    data: {
      document,
      documentWithCoOwners,
    },
    isLoading,
  };
};
